/**
 * Different display modes
 */
export enum DisplayModeEnum {
  text = 'html',
  pdf = 'pdf'
}
